import React, { Component } from 'react';

import cx from 'classnames';
import _memoize from 'lodash.memoize';
import _isEmpty from 'lodash.isempty';
import FiltersMobile from './FiltersMobile';
import AdvancedFilters from '../../../../AdvancedFilters';
import Input from '../../../../Input';
import Button from '../../../../Button';
import Dropdown from '../../../../Dropdown';
import Icon from '../../../../Icon';
import ListViewSelector from './ListViewSelector';
import { LIST_VIEW, GRID_VIEW } from '../../../constants/viewTypes';

import Text from '../../../../Text';
import {
  FILTERS_CONTAINER,
  SEARCH_CLS,
  FILTER_TOGGLE_CONTAINER,
  FILTER_TOGGLE,
  RIGHT_CONTENT_CLS,
  DROPDOWN_CLS,
  FILTERS_MOBILE,
  FILTERS_MOBILE_ICONS_CONTAINER } from
'../styles/filters';
import '../styles/_filters.scss';
import { getFilterValue } from '../utils/filtersValues';

















































class Filters extends Component {
  onSelectFilter = _memoize((filterName) => (selectedFilterValue) => {
    const { setSelectedFilters } = this.props;

    setSelectedFilters(getFilterValue(filterName, selectedFilterValue));
  });

  constructor() {
    super();

    this.state = {
      searchVisible: false
    };
  }

  toggleSearchBarVisibility = () => this.setState(({ searchVisible }) => ({
    searchVisible: !searchVisible
  }));

  handleResetFilters = () => {
    const { resetFilters } = this.props;

    resetFilters();
  };

  render() {
    const {
      history,
      isMobile,
      loading,
      onSearch,
      bothViewsAvailable,
      usePitchListView,
      view,
      onChangeView,
      selectedFilters,
      setSelectedFilters,
      filters,
      advancedFilters = null,
      onAdvancedFiltersChange,
      sortFilters = null,
      selectedSort = null,
      onSortFiltersChange,
      filtersLeftAddon,
      filtersRightAddon,
      totalResults,
      numberOfItems,
      searchTerm,
      customSearchText,
      isCollapsible,
      customPrefix,
      containerSize,
      numResults,
      stats,
      searchInputPlaceholder,
      shouldReturnOptionAllSelections,
      advanceFilterName,
      isAdvancedFilterPersistent,
      initialUpdate,
      hideSearchFilter = false,
      hideFilterDropdown = false,
      isSearchBarCollapsed = false,
      alignSearchRight = false,
      searchSuffix,
      renderSearchBottomInfo,
      isCompactMenuButton = false
    } = this.props;

    const { searchVisible } = this.state;
    const hasFilters = !!Object.keys(filters).length;
    const hasAdvancedFilters = !!advancedFilters;
    const isAdvancedFiltersOnly = !hasFilters && hasAdvancedFilters;
    const shouldShowFilters = hasFilters || hasAdvancedFilters;
    const clearButton = !_isEmpty(searchSuffix) ?
    <div className="filters__search--clear-btn-with-suffix">
        {searchSuffix}
        <Icon
        name="close"
        size={10}
        color="regent"
        className="filters__search--clear-btn-with-suffix__icon" />

      </div> :

    <Icon name="close" size={10} color="regent" />;


    return (
      <>
        <div
          className={cx(
            'filters__container',
            FILTERS_CONTAINER({ isMobile, alignSearchRight })
          )}>

          {filtersLeftAddon}
          <div
            className={cx('filters__search', {
              'filters__search--mobile': isMobile
            })}
            style={{ flexGrow: !_isEmpty(searchSuffix) && 1 }}>

            {!hideSearchFilter && (
            !isSearchBarCollapsed || searchVisible ?
            <>
                  <Input
                id="filter-search"
                className={cx(
                  'filters__input',
                  SEARCH_CLS({
                    isMobile,
                    alignSearchRight,
                    hideSearchFilter
                  }),
                  { 'filters__search--is-suffix': !_isEmpty(searchSuffix) }
                )}
                prefix="search"
                suffixIcon={searchSuffix}
                onBlur={this.toggleSearchBarVisibility}
                onChange={onSearch}
                clearButton={clearButton}
                placeholder={searchInputPlaceholder || 'Search'}
                defaultValue={searchTerm} />

                  {renderSearchBottomInfo && renderSearchBottomInfo()}
                </> :

            <Button
              onClick={this.toggleSearchBarVisibility}
              type="SECONDARY"
              className={cx('filters__toggle-btn', FILTER_TOGGLE)}
              style={{
                marginRight:
                alignSearchRight && !hideFilterDropdown && '16px'
              }}
              prefix={<Icon name="search" size={15} />}
              id="filters-input-search-btn" />)}


            {!loading && (searchTerm || customSearchText) &&
            <Text label noMargin>
                {`${numberOfItems ||
              totalResults ||
              0} results found`}
              </Text>}


            {!hideFilterDropdown &&
            shouldShowFilters &&
            isMobile && (
            isAdvancedFiltersOnly ?
            <AdvancedFilters
              name={advanceFilterName}
              history={history}
              location={window.location}
              filters={advancedFilters}
              onUpdateFilters={onAdvancedFiltersChange}
              isCollapsible={isCollapsible}
              containerSize={containerSize}
              numResults={numResults}
              stats={stats}
              isCompactMenuButton
              shouldReturnOptionAllSelections={
              shouldReturnOptionAllSelections}

              isPersistent={isAdvancedFilterPersistent}
              initialUpdate={initialUpdate}
              selectedFiltersProps={selectedFilters} /> :


            <div
              className={cx('filters__toggle-btn', FILTER_TOGGLE_CONTAINER)}>

                  <FiltersMobile
                history={history}
                setSelectedFilters={setSelectedFilters}
                resetFilters={this.handleResetFilters}
                selectedFilters={selectedFilters}
                filters={filters}
                advancedFilters={advancedFilters}
                onAdvancedFiltersChange={onAdvancedFiltersChange}
                isCollapsible={isCollapsible}
                containerSize={containerSize}
                numResults={numResults}
                stats={stats}
                shouldReturnOptionAllSelections={
                shouldReturnOptionAllSelections} />


                </div>)}

          </div>
          {shouldShowFilters && (
          isMobile ?
          <div className={cx('filters__mobile', FILTERS_MOBILE)}>
                <div
              className={cx(
                'filters__mobile__icons-container',
                FILTERS_MOBILE_ICONS_CONTAINER
              )}>

                  <ListViewSelector
                view={view}
                onChangeView={onChangeView}
                bothViewsAvailable={bothViewsAvailable}
                usePitchListView={usePitchListView}
                isMobile={isMobile} />

                </div>
              </div> :

          !hideFilterDropdown &&
          <div
            className={cx('filters__right-content', RIGHT_CONTENT_CLS)}>

                  {Object.keys(filters).map((key) => Array.isArray(filters[key]) ?
            <Dropdown
              key={key}
              id={`all-filter-dropdown-${key}`}
              className={cx('filters__dropdown', DROPDOWN_CLS)}
              options={filters[key]}
              defaultValue={selectedFilters[key] || filters[key][0]}
              customPrefix={customPrefix}
              prefixSize={18}
              onChange={this.onSelectFilter(key)}
              fontSize={12}
              type="BUTTON" /> :


            <Dropdown
              key={key}
              id={`all-filter-dropdown-${key}`}
              className={cx('filters__dropdown', DROPDOWN_CLS)}
              options={filters[key].options || []}
              onChange={this.onSelectFilter(key)}
              customPrefix={customPrefix}
              prefixSize={18}
              fontSize={12}
              type="BUTTON"
              {...filters[key]} />


            )}
                  {sortFilters &&
            <Dropdown
              key="sortFilters"
              id="sort-filter-dropdown"
              className={cx('filters__dropdown', DROPDOWN_CLS)}
              options={sortFilters}
              defaultValue={selectedSort || 'Sort By: '}
              value={selectedSort || 'Sort By: '}
              customPrefix={customPrefix}
              prefixSize={18}
              onChange={onSortFiltersChange}
              fontSize={12}
              type="BUTTON" />}


                  {advancedFilters && Boolean(advancedFilters.length) &&
            <AdvancedFilters
              name={advanceFilterName}
              history={history}
              location={window.location}
              filters={advancedFilters}
              onUpdateFilters={onAdvancedFiltersChange}
              isCollapsible={isCollapsible}
              containerSize={containerSize}
              numResults={numResults}
              stats={stats}
              shouldReturnOptionAllSelections={
              shouldReturnOptionAllSelections}

              isPersistent={isAdvancedFilterPersistent}
              initialUpdate={initialUpdate}
              isCompactMenuButton={isCompactMenuButton}
              selectedFiltersProps={selectedFilters} />}


                  <ListViewSelector
              view={view}
              onChangeView={onChangeView}
              bothViewsAvailable={bothViewsAvailable}
              usePitchListView={usePitchListView} />

                </div>)}


          {filtersRightAddon}
        </div>
      </>);

  }
}

export default Filters;